import { Box, IconButton } from "@mui/material";
import Image, { StaticImageData } from "next/image";

import { theme } from "../../mui-customs/Theme";
import Typography from "../Typography";

interface NavButtonProps {
  imageSrc: StaticImageData;
  label: string;
  onClick?: () => void;
  isActive?: boolean;
}
const NavButton = ({ imageSrc, label, onClick, isActive }: NavButtonProps) => {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        position: "relative",
        pb: "1rem",
      }}
    >
      <IconButton
        sx={{
          backgroundColor: `${isActive ? theme.brand1[400] : theme.grey2[150]}`,
          height: "32px",
          width: "32px",
          borderRadius: "0.5rem",
          ":hover": {
            backgroundColor: theme.brand1[400],
          },
        }}
        onClick={onClick}
      >
        <Image alt="IconImage" src={imageSrc} />
      </IconButton>
      <Typography
        variant="small5"
        sx={{
          color: theme.grey2[500],
          position: "absolute",
          bottom: "-0.5rem",
        }}
      >
        {label}
      </Typography>
    </Box>
  );
};

export default NavButton;
